import { render, staticRenderFns } from "./FormLocale.vue?vue&type=template&id=3619d399"
import script from "./FormLocale.vue?vue&type=script&lang=js"
export * from "./FormLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports